import { Layout } from "../../UI/Layout/Layout.tsx";
import { Card } from "../../UI/Card.tsx";
import { ScreenTitleBlock } from "../../UI/Layout/ScreenTitleBlock.tsx";
import { BreadCrumbsWrapper } from "../../UI/Layout/BreadCrumbsWrapper.tsx";
import { BreadCrumbsItem } from "../../UI/Layout/BreadCrumbsItem.tsx";
import { FullPageLoading } from "../../UI/Loading/FullPageLoading.tsx";
import { useUserIdParamsOrThrow } from "../useUserIdParamsOrThrow.ts";
import { useUserById } from "../useUserById.ts";
import { useToAllUsers } from "../useToAllUsers.ts";
import { UserClassRoomHistoryComponent } from "./UserClassRoomHistoryComponent.tsx";

export const UserClassRoomHistoryScreenPath = "/users/:userId/class-rooms";

export function UserClassRoomHistoryScreen() {
  const { userId } = useUserIdParamsOrThrow();
  const { user, loading } = useUserById(userId);
  const { toAllUsers } = useToAllUsers();

  if (loading) return <FullPageLoading />;
  if (!user) return null; //TODO return not found

  const userFullName =
    user.givenName.length > 0 || user.familyName.length > 0
      ? `${user.givenName} ${user.familyName}`.trim()
      : user.email;

  return (
    <Layout>
      <Card>
        <ScreenTitleBlock
          title={`${userFullName}'s classes`}
          subTitle={
            <p className={"text-sm text-slate-500"}>
              All the classes {userFullName} took part in.
            </p>
          }
          breadCrumbs={
            <BreadCrumbsWrapper>
              <BreadCrumbsItem onClick={toAllUsers} title={"Users"} />
              <BreadCrumbsItem title={"Classes"} />
            </BreadCrumbsWrapper>
          }
        />
      </Card>
      <div className={"mt-4"}>
        <Card>
          <UserClassRoomHistoryComponent
            userId={userId}
            userFullName={userFullName}
          />
        </Card>
      </div>
    </Layout>
  );
}
